<template>
    <v-row align="center">
        <v-expansion-panels
                :accordion=true
                :tile=true
                :value="0"
        >
            <v-col cols="12">
                <v-expansion-panel>
                    <v-expansion-panel-header>מוצרים בהזמנה</v-expansion-panel-header>
                    <v-expansion-panel-content v-if="products && products.length">
                        <v-simple-table>
                            <template>
                                <thead>
                                <tr>
                                    <th class="text-right">מוצר</th>
                                    <th class="text-right">כמות</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="product in products" :key="product.product.name" v-if="product.product.id !== '1194472000040866020'">
                                    <td>{{ product.product.name }}</td>
                                    <td>{{ product.quantity }}</td>
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content v-else>
                        <v-skeleton-loader
                            type="table-heading, divider, list-item, divider, list-item, divider, list-item"
                        ></v-skeleton-loader>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-col>
        </v-expansion-panels>
    </v-row>
</template>
<script>
    export default {
        name: "vProductPanel",
        components: {
        },
        props: ['products'],
        data: function() {
            return {
            }
        },

    }
</script>
